import React from 'react'
import SelectField from 'discada/dist/Form/SelectField'
import { toTitleCase } from 'utils'

export const RegionSelectField = ({
  taxRegionId,
  regionConfigurations = {},
  onChange,
  allowAutoTaxRate,
}) => {
  let optionReducer = (ret, k) => {
      let region = regionConfigurations[k]

      return {
        ...ret,
        [k]: toTitleCase(
          [
            region.RegionName,
            region.InCity ? 'In city' : 'Out of city',
            region.SubregionID ? `Subregion: ${region.SubregionID}` : false,
          ]
            .filter(Boolean)
            .join(' - '),
        ),
      }
    },
    options = Object.keys(regionConfigurations)
      .sort()
      .reduce(optionReducer, {})

  if (allowAutoTaxRate) options = { '': 'Automatic', ...options }
  else options = { ...options, '': "I don't know" }

  return (
    <SelectField
      rounded
      icon="map"
      onChange={onChange}
      value={taxRegionId || ''}
      options={options}
    />
  )
}

export default RegionSelectField
